import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"


import { defineComponent, ref, defineProps, onMounted, watch, defineEmits } from 'vue'
import { apiFetchData, isEmptyString, tryParseArray, getI18n } from '../utils'

const __default__ = defineComponent({
  name: 'DropDownSelector'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  dataValue: {
    type: String,
    require: true
  },
  multiple: {
    type: Boolean,
    require: false,
    default: false
  },
  allowCreate: {
    type: Boolean,
    require: false,
    default: false
  },
  srcDataUrl: {
    type: String,
    require: true
  },
  isShowQueryZone: {
    type: Boolean,
    default: false,
    require: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const refValue = ref(Object)
const refOptions = ref([])
let optionsCopy = []

// mounted时
onMounted(async () => {
  const data = await apiFetchData(props.srcDataUrl)
  optionsCopy = data.data.map(item => {
    return {
      ...item,
      label: getI18n(item.label)
    }
  })
  refOptions.value = optionsCopy

  if (props.isShowQueryZone) {
    return
  }
  if (optionsCopy.length === 1) {
    // 当只有一个 选项时， 则直接选中
    refValue.value = optionsCopy[0].value
    return
  }
  if (isEmptyString(props.dataValue)) {
    return
  }
  const curValue = tryParseArray(props.dataValue)
  if (Array.isArray(curValue)) {
    // 多选暂时不判断是否在 选项 中
    refValue.value = curValue
    return
  }
  for (let i = 0; i < data.data.length; i++) {
    if (data.data[i].value === curValue) {
      refValue.value = curValue
      return
    }
  }
  refValue.value = ''
})

// 主动实现 通知到 父组件
const emit = __emit // 定义 'update:modelValue' 事件

// 监听 refValue 的变化，并触发事件
watch(refValue, (newValue) => {
  console.log(refValue, newValue)
  emit('update:modelValue', newValue) // 当 refValue 改变时触发事件
})

const customFilter = (query :string) => {
  if (query !== '') { // val存在
    // 使用空格将字符串拆分成数组
    const arr = query.trim().split(' ')
    refOptions.value = optionsCopy.filter((item) => {
      for (let i = 0; i < arr.length; i++) {
        const currentValue = arr[i].toLowerCase()
        if (currentValue === '') {
          continue
        }
        // 有不包括的元素
        if (item.label.toLowerCase().indexOf(currentValue.toLowerCase()) < 0) {
          return false
        }
      }
      return true
    })
  } else { // val为空时，还原数组
    refOptions.value = optionsCopy
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: refValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refValue).value = $event)),
    filterable: "",
    "allow-create": props.allowCreate,
    multiple: props.multiple,
    "filter-method": customFilter,
    placeholder: "Select",
    style: {"width":"100%"},
    clearable: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refOptions.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "allow-create", "multiple"]))
}
}

})